import jwt_decode from 'jwt-decode'
import { camelizeKeys } from 'humps'
import { IUserModel } from 'models/user.model'
import { getJWT } from './cookies.helper'

export const getUserSession = () => {
  const jwt = getJWT()
  const userData = camelizeKeys(jwt_decode(jwt)) as unknown as IUserModel
  return userData
}
